export type Color = '' | 'gray' | 'red' | 'yellow' | 'green' | 'blue' | 'indigo' | 'purple' | 'pink';

export interface IThemeColor {
  bgColor: string
  bgColorLight: string
  textColor: string
  borderColor: string
  hoverBgColor: string
  hoverBgColorLighter: string
  focusBgColor: string
  focusWiBorderColor: string
}

export type IThemeColorKey = keyof IThemeColor;

export interface IThemeColors {
  // [key in Color]: IThemeColor;
  [key: string]: IThemeColor;
};

export const ThemeColors: IThemeColors = {
  gray: {
    bgColor: 'bg-gray-700',
    bgColorLight: 'bg-gray-100',
    textColor: 'text-gray-700',
    borderColor: 'border-gray-500',
    hoverBgColor: 'hover:bg-gray-500',
    hoverBgColorLighter: 'hover:bg-gray-100',
    focusBgColor: 'focus:bg-gray-300',
    focusWiBorderColor: 'focus-within:border-gray-500'
  },
  red: {
    bgColor: 'bg-red-700',
    bgColorLight: 'bg-red-100',
    textColor: 'text-red-700',
    borderColor: 'border-red-500',
    hoverBgColor: 'hover:bg-red-500',
    hoverBgColorLighter: 'hover:bg-red-100',
    focusBgColor: 'focus:bg-red-300',
    focusWiBorderColor: 'focus-within:border-red-500'
  },
  orange: {
    bgColor: 'bg-orange-700',
    bgColorLight: 'bg-orange-100',
    textColor: 'text-orange-700',
    borderColor: 'border-orange-500',
    hoverBgColor: 'hover:bg-orange-500',
    hoverBgColorLighter: 'hover:bg-orange-100',
    focusBgColor: 'focus:bg-orange-300',
    focusWiBorderColor: 'focus-within:border-orange-500'
  },
  yellow: {
    bgColor: 'bg-yellow-700',
    bgColorLight: 'bg-yellow-100',
    textColor: 'text-yellow-700',
    borderColor: 'border-yellow-500',
    hoverBgColor: 'hover:bg-yellow-500',
    hoverBgColorLighter: 'hover:bg-yellow-100',
    focusBgColor: 'focus:bg-yellow-300',
    focusWiBorderColor: 'focus-within:border-yellow-500'
  },
  green: {
    bgColor: 'bg-green-700',
    bgColorLight: 'bg-green-100',
    textColor: 'text-green-700',
    borderColor: 'border-green-500',
    hoverBgColor: 'hover:bg-green-500',
    hoverBgColorLighter: 'hover:bg-green-100',
    focusBgColor: 'focus:bg-green-300',
    focusWiBorderColor: 'focus-within:border-green-500'
  },
  teal: {
    bgColor: 'bg-teal-700',
    bgColorLight: 'bg-teal-100',
    textColor: 'text-teal-700',
    borderColor: 'border-teal-500',
    hoverBgColor: 'hover:bg-teal-500',
    hoverBgColorLighter: 'hover:bg-teal-100',
    focusBgColor: 'focus:bg-teal-300',
    focusWiBorderColor: 'focus-within:border-teal-500'
  },
  blue: {
    bgColor: 'bg-blue-700',
    bgColorLight: 'bg-blue-100',
    textColor: 'text-blue-700',
    borderColor: 'border-blue-500',
    hoverBgColor: 'hover:bg-blue-500',
    hoverBgColorLighter: 'hover:bg-blue-100',
    focusBgColor: 'focus:bg-blue-300',
    focusWiBorderColor: 'focus-within:border-blue-500'
  },
  indigo: {
    bgColor: 'bg-indigo-700',
    bgColorLight: 'bg-indigo-100',
    textColor: 'text-indigo-700',
    borderColor: 'border-indigo-500',
    hoverBgColor: 'hover:bg-indigo-500',
    hoverBgColorLighter: 'hover:bg-indigo-100',
    focusBgColor: 'focus:bg-indigo-300',
    focusWiBorderColor: 'focus-within:border-indigo-500'
  },

  purple: {
    bgColor: 'bg-purple-700',
    bgColorLight: 'bg-purple-100',
    textColor: 'text-purple-700',
    borderColor: 'border-purple-500',
    hoverBgColor: 'hover:bg-purple-500',
    hoverBgColorLighter: 'hover:bg-purple-100',
    focusBgColor: 'focus:bg-purple-300',
    focusWiBorderColor: 'focus-within:border-purple-500'
  },
  pink: {
    bgColor: 'bg-pink-700',
    bgColorLight: 'bg-pink-100',
    textColor: 'text-pink-700',
    borderColor: 'border-pink-500',
    hoverBgColor: 'hover:bg-pink-500',
    hoverBgColorLighter: 'hover:bg-pink-100',
    focusBgColor: 'focus:bg-pink-300',
    focusWiBorderColor: 'focus-within:border-pink-500'
  },

}

